/*
 * Copyright (c), Onnorokom Web Services Ltd (OWSL) and/or its affiliates. All rights reserved.
 * OWSL PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

const pageContext = $('meta[name=context-path]').attr('content');
const CSRF = $("meta[name='csrf-token']").attr('content');
const cartId = $('#js--cart-id').val();
const accountId = $('#js--account-id').val();
const orderId = $('#js--order_id').val();
const orderNo = $('#js--order_no').val();
const orderCancelInput = document.querySelectorAll('.js-order-cancelled');
const phoneNumber = document.getElementById('js--order_phone') && document.getElementById('js--order_phone').getAttribute("value");


$(() => {

    $('#myModal').on('shown.bs.modal', function () {
      $('#myInput').trigger('focus');
    });

    
    let affBaseURL;
    if(location.hostname == "www.rokomari.com") {
        affBaseURL = "https://affiliateback.rokomari.io"
    } else if (location.hostname == "www.rokomari.club") {
        affBaseURL = "https://share.rokomari.club"
    } else {
        affBaseURL = "http://localhost:4800"
    }

    const savedData =  JSON.parse(localStorage.getItem('rokaf')) || false;

    let isSpecific;

    isSpecific = savedData ? document.cookie.includes(`isSpecific=${savedData.isSpecific}`) : false; // check if there is isSpecific flag in cookie

    const AllProduct = JSON.parse(localStorage.getItem('sPr'));
  
    if(isSpecific && (location.pathname.includes('/order-place-success') || location.pathname.includes('/confirmation') || location.pathname.includes('/payment')) && AllProduct != null) {
        const productMatch = AllProduct.products.filter(el => el.id == savedData.productId);
        
        let customerBillPaymentMethod;
        switch (paymentMethodCustomer) {
            case 'COD':
                customerBillPaymentMethod = "COD"
                break;
            case '1':
                customerBillPaymentMethod = "BKASH"
                break;
            case '3':
                customerBillPaymentMethod = "ROCKET"
                break;
            case '8':
                customerBillPaymentMethod = "SSL"
                break;
            case '17':
                customerBillPaymentMethod = "NAGAD"
                break;
            default:
                break;
        }

        const conversionData = {
            "affNanoId": savedData.affNanoId,
            "affNumericId": savedData.affNumericId,
            "assetId": savedData.assetId ? savedData.assetId : undefined,
            "isSpecific": savedData.isSpecific,
            "affiliationLink": savedData.affURL,
            "clickDate": `${savedData.clickDate}`,
            "userAgent": navigator.userAgent,
            "conversionDate": `${Date.now()}`,
            "orderId": `${orderNo}`,
            "phoneNumber": `${phoneNumber}`,
            "cartId": cartId,
            "customerId": accountId,
            "paymentMethod": customerBillPaymentMethod,
            "totalAmount": productMatch.length > 0 ? productMatch[0].price : 0,
            "products": AllProduct.products
        }

        if(savedData.isSpecific && productMatch.length && savedData.productId) {
            $.ajax({
                type: "POST",
                url: affBaseURL + `/conversion/specific`,
                data: JSON.stringify(conversionData),
                contentType: "application/json",
                success: function (response) {
                    if(savedData.isSpecific) {
                        localStorage.removeItem('rokaf');
                        const specificCookie = `isSpecific=; max-age=-1; path=/`;
                        document.cookie = specificCookie;
                    }
                },
                error: function() {
                    if(savedData.isSpecific) {
                        localStorage.removeItem('rokaf');
                        const specificCookie = `isSpecific=; max-age=-1; path=/`;
                        document.cookie = specificCookie;
                    }
                }
            });
        } else if (!savedData.isSpecific) {
            $.ajax({
                type: "POST",
                url: affBaseURL + '/conversion/special-basic',
                data: JSON.stringify(conversionData),
                contentType: "application/json",
                success: function (response) {}
            });
        }
    } else if ( !isSpecific && savedData) {
        localStorage.removeItem('rokaf');
    }

    if((location.pathname.includes('/order-place-success') || location.pathname.includes('/confirmation') || location.pathname.includes('/payment')) && AllProduct != null) {
        localStorage.removeItem('sPr');
    }
});

  $('.js--cancelOrder').click(function(){
    $.get( pageContext + "/order/client-cancel-reason", function( data ) {
        for (let i=0;i<data.length;i++){
            $('<option>').val(data[i].key).text(data[i].value).appendTo('#js--order-cancel-reason');
        }
    });
  })

  $('.js--btn-submit-cancel_confirmation').click(() => {

      let orderId = $('.js--btn-submit-cancel_confirmation').data('id');
      let phone = $('.js--btn-submit-cancel_confirmation').data('phone');
      let reason = $('#js--order-cancel-reason option:selected').val();
      let details = $('#js--order-cancel-reason-detail').val();

      $('#js--order-cancel-reason').change(function () {
          $(this).css('borderColor', '#E2E2E2');
          $('.js--btn-submit-cancel_confirmation').removeAttr('disabled').css('cursor', 'pointer');
      });

      if (reason === '') {
         $('#js--order-cancel-reason').css('borderColor', '#D64541');
         $('.js--btn-submit-cancel_confirmation').attr('disabled', 'true').css('cursor', 'not-allowed');
         return false;
      } else {
         $('#js--order-cancel-reason').css('borderColor', '#E2E2E2');
         $('.js--btn-submit-cancel_confirmation').removeAttr('disabled').css('cursor', 'pointer');

           $.ajax({
                   type: "POST",
                   url:  pageContext + "/order/cancel",
                   data: "orderNo=" + orderId + '&phoneNumber='+ phone + '&reason=' + reason + "&_tk=" + CSRF,

                   success: function (response) {
                       if (response.result == true) {
                           $('.js--content-wrapper').slideUp();
                           $('.js--order-cancel-success-msg').slideDown();
                           $('.js--order-cancel-success-confirm-msg').text(response.message);
                           location.reload();
                       }
                       else {
                           $('.js--content-wrapper').slideUp();
                           $('.js--order-cancel-fail-msg').slideDown();
                           $('.js--order-cancel-fail-confirm-msg').text(response.message);
                           location.reload();
                       }
                   },
                   error: function (error) {
                      $('.js--content-wrapper').slideUp();
                      $('.js--order-cancel-fail-msg').slideDown();
                      location.reload();
                   },
                   complete: function () {}
           });
       }
  });